import { Allocation, AllocationChange } from '@/types/vehicleAllocation'
import { useVehicleAllocationStore } from '../store'
import { useEffect } from 'react'
import { ModalTypes, useModal } from '@/components/Modal'

export const useChangeRunModal = (
    allAllocations: Allocation[],
    isManualEdit: boolean,
    allocation: Allocation,
    allocationChange?: AllocationChange
) => {
    const { openModal } = useModal()
    const { allocationChanges, setAllocationChanges, swappedBuses, setSwappedBuses } = useVehicleAllocationStore()

    const handleConfirmChangeRun = (oldRun: string) => {
        const filteredAllocationChanges = allocationChanges.filter((allocation) => allocation.run !== oldRun) ?? []

        setAllocationChanges([
            ...filteredAllocationChanges,
            {
                run: oldRun,
                fleetNumber: null,
            },
        ])
    }

    const handleCancelChangeRun = (newRun: string) => {
        const filteredAllocationChanges = allocationChanges.filter((allocation) => allocation.run !== newRun) ?? []
        setAllocationChanges(filteredAllocationChanges)

        const originalRun = allAllocations.find((allocation) => allocation.run === newRun)
        const filteredSwappedBuses = swappedBuses.filter((bus) => bus !== originalRun?.bonnet)
        setSwappedBuses(filteredSwappedBuses)
    }

    useEffect(() => {
        if (allocationChange?.fleetNumber) {
            // 'CHANGE RUN' MODAL
            if (!isManualEdit) {
                return
            }
            // skip if chosen value in swapped buses
            if (swappedBuses.includes(allocationChange.fleetNumber)) {
                return
            }

            const isAssignedToAnotherChangedRun = allocationChanges
                .filter((allocation) => allocation.run !== allocationChange.run)
                .find((allocation) => allocation.fleetNumber === allocationChange.fleetNumber)

            if (isAssignedToAnotherChangedRun) {
                openModal(ModalTypes.changeRunModal, {
                    oldRun: isAssignedToAnotherChangedRun.run,
                    newRun: allocation.run,
                    confirm: () => handleConfirmChangeRun(isAssignedToAnotherChangedRun.run),
                    cancel: () => handleCancelChangeRun(allocation.run),
                })

                return
            }

            // check if chosen value is already assigned to another run
            const isAssignedToAnotherRun = allAllocations.find(
                (allocation) => allocation.bonnet === allocationChange.fleetNumber
            )

            if (isAssignedToAnotherRun) {
                openModal(ModalTypes.changeRunModal, {
                    oldRun: isAssignedToAnotherRun.run,
                    newRun: allocation.run,
                    confirm: () => handleConfirmChangeRun(isAssignedToAnotherRun.run),
                    cancel: () => handleCancelChangeRun(allocation.run),
                })
            }
        }
    }, [allocationChange?.fleetNumber])
}
